import React from 'react';
import { Box, Typography } from '@mui/material';
import type { PosilovaNotifikaceLogResponse } from '../api/JsdhNotifikaceService/generated/models/PosilovaNotifikaceLog';

interface ZpravyOdAdminaProps {
    notifikace: PosilovaNotifikaceLogResponse[];
}

const formatTime = (iso: string) => {
    const d = new Date(iso);
    return `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`;
};

const pickLatest = (
    list: PosilovaNotifikaceLogResponse[],
    typ: 'ZPRAVA' | 'POSILOVA_TECHNIKA'
): PosilovaNotifikaceLogResponse | null => {
    const filtered = list
        .filter(n => (n.typ ?? 'ZPRAVA') === typ) // fallback: bez typ → ZPRAVA
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    return filtered[0] ?? null;
};

export const ZpravyOdAdmina: React.FC<ZpravyOdAdminaProps> = ({ notifikace }) => {
    const obecna = pickLatest(notifikace, 'ZPRAVA');
    const posila = pickLatest(notifikace, 'POSILOVA_TECHNIKA');

    if (!obecna && !posila) return null;

    return (
        <Box sx={{ mt: 0, p: 1, borderRadius: 1, bgcolor: 'action.hover' }}>
            <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: 'text.secondary', mb: 0.5 }}>
                Zprávy:
            </Typography>
            {obecna && (
                <Typography sx={{
                    fontSize: '1rem', fontWeight: 500, lineHeight: 1.35, mb: posila ? 0.75 : 0,
                    display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical',
                    overflow: 'hidden', textOverflow: 'ellipsis',
                }}>
                    <Box component="span" sx={{ color: 'text.secondary', fontWeight: 700 }}>
                        {obecna.odeslalJmeno || 'Admin'} ({formatTime(obecna.createdAt)}):
                    </Box>
                    {' '}
                    {obecna.text}
                </Typography>
            )}
            {posila && (
                <Typography sx={{
                    fontSize: '1rem', fontWeight: 500, lineHeight: 1.35,
                    display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical',
                    overflow: 'hidden', textOverflow: 'ellipsis',
                }}>
                    <Box component="span" sx={{ color: 'error.main', fontWeight: 700 }}>
                        POSILA — {posila.odeslalJmeno || 'Admin'} ({formatTime(posila.createdAt)}):
                    </Box>
                    {' '}
                    {posila.text}
                </Typography>
            )}
        </Box>
    );
};
